import React from "react";
import { AiOutlineCopyright } from "react-icons/ai";

const FooterBottom = () => {
  return (
    <div className="w-full bg-[#F5F5F3] group">
      <div className="max-w-container mx-auto border-t-[1px] pt-10 pb-20">
        <p className="text-titleFont font-normal text-center flex md:items-center justify-center text-lightText duration-200 text-sm">
          <span className="text-md mr-[1px] mt-[2px] md:mt-0 text-center hidden md:inline-flex">
            <AiOutlineCopyright />
          </span>
          Copyright 2024 | MD Wedding Props | All Rights Reserved | Created by{" "}
          <a
            href="https://wa.me/919880739285?text=Hi%20Abhiram,%20I%20saw%20your%20work%20on%20MD%20Wedding%20Props%20website%20and%20wanted%20to%20reach%20out!"
            target="_blank"
            rel="noreferrer"
            className="ml-1 font-medium group-hover:text-primeColor"
          >
            @abhiram
          </a>
        </p>
      </div>
    </div>
  );
};

export default FooterBottom;
